'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.requestPermission = requestPermission;
exports.show = show;
exports.listenForNewMessages = listenForNewMessages;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEnabled = false;

function requestPermission() {
    if (!('Notification' in window)) {
        isEnabled = false;
        return;
    }

    if (Notification.permission === 'granted') {
        isEnabled = true;
    }

    if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
            if (permission === 'granted') {
                isEnabled = true;
            } else {
                isEnabled = false;
            }
        });
    }
}

function show(title, body, opts) {
    if (!isEnabled) {
        return false;
    }

    var notify = new Notification(title, {
        body: body,
        icon: opts.icon
    });

    if (opts.ttl) {
        setTimeout(notify.close.bind(notify), opts.ttl);
    }

    return notify;
}

var throttledShow = _lodash2.default.throttle(show, 2000);

function listenForNewMessages(state) {
    state.$on('notification.show', function (message, _opts) {
        if (!isEnabled) {
            return;
        }

        var opts = (0, _assign2.default)({
            title: 'Kiwi IRC',
            message: message,
            icon: '',
            onclick: null,
            ttl: 10000
        }, _opts);

        if (!opts.message) {
            return;
        }

        var notification = throttledShow(opts.title, opts.message, {
            ttl: opts.ttl
        });

        if (notification && typeof opts.onclick === 'function') {
            notification.onclick = opts.onclick;
        }
    });
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["Notifications"]
window._kiwi_exports.libs.Notifications = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/Notifications.js
// module id = 0R7g
// module chunks = 1